// Logos
import facebook from '../images/facebook.svg'
import instagram from '../images/instagram-icon.svg'
import twitter from '../images/twitter.svg'
import linkedin from '../images/linkedin-logo.svg'

// Arrows
import arrowInCircle from '../images/arrow-in-circle.svg'
import arrowDark from '../images/vector.svg'

export const logos = {
  facebook: {
    logo: facebook,
    alt: 'facebook logo',
  },
  instagram: {
    logo: instagram,
    alt: 'instagram logo',
  },
  twitter: {
    logo: twitter,
    alt: 'twitter logo',
  },
  linkedin: {
    logo: linkedin,
    alt: 'linkedin logo',
  },
}

export const arrows = {
  arrowInCircle,
  arrowDark
}
